module.exports = __webpack_public_path__ + "img/milun.3dc37af5.png";